/**
 * Returns the capitalized format of a word.
 *
 * @param {string} word - Word to capitalize
 * @returns Capitalized word
 */
export const getCapitalizedWord = (word: string): string => {
    return word
        ? `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
        : ''
}

/**
 * Transforms positive number to at least two digits even if its below 10.
 *
 * @param {number} source - Positive number to transform to two digits
 * @returns Stringified version of the number with at least two digits
 */
export const transformNumberToAtLeastTwoDigits = (source: number) => {
    if (source < 10 && source > 0) {
        return ['0', source].join('')
    } else {
        return source.toString()
    }
}

/**
 * Transforms number to number with "n" decimal places.
 *
 * @param {number} value - Number to transform to number with "n" decimals
 * @param {number} n - Number if decimal places
 * @returns a floating point number with the specified decimal precision
 */
export const formatNumberToNumberWithSpecifiedDecimals = (
    value: number,
    n: number
): number => {
    return Number(Number.parseFloat(value.toString()).toFixed(n))
}
